
import { Vue, Options } from "vue-class-component";
import Nav from "../../components/nav/Nav.vue";
import Prize from "../../components/lottery/Prize.vue";
import { Urls } from "../../net/Urls";
import { Http, ResponseData } from "../../net/Http";
import { Phases } from "../../model/lottery/LotteryModel";
import { TimerFormatter } from "../../hooks/TimerFormatter";

@Options({
  components: {
    Nav,
    Prize
  }
})
export default class PaseWinnersList extends Vue {
  datas: Phases[] = [];
  //是否开奖品
  isDraw = true;
  mounted() {
    this.initData();
  }
  initData() {
    Http.get<Phases[]>(Urls.lottery_phases).then(
      (res: Phases[]) => {
        this.datas = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_phases, err.message);
        // openToast(err.message);
      }
    );
  }
  lotteryTimerFormatter(index: number) {
    return TimerFormatter.lotteryTimerFormatter(
      this.datas[index].drawTime.toString()
    );
  }
}
